import * as React from "react";

function CartIcon(props) {
	return (
		<svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M208 416 A32 32 0 0 1 176 448 A32 32 0 0 1 144 416 A32 32 0 0 1 208 416 z" />
      <path d="M432 416 A32 32 0 0 1 400 448 A32 32 0 0 1 368 416 A32 32 0 0 1 432 416 z" />
      <path d="M456.8 120.78a23.92 23.92 0 00-18.56-8.78H133.89l-6.13-34.78A16 16 0 00112 64H48a16 16 0 000 32h50.58l45.66 258.78A16 16 0 00160 368h256a16 16 0 000-32H173.42l-5.64-32h241.66A24.07 24.07 0 00433 284.71l28.8-144a24 24 0 00-5-19.93z" />
    </svg>
	);
}

export default CartIcon;
